import React, { createContext, useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';

const PauseModalContext = createContext(null);

export function PauseModalProvider ({
  spaceID,
  spaceTitle,
  spaceImage,
  spaceAddress,
  listingID,
  listingsIDs,
  listingStatus,
  listingType,
  intl,
  router,
  dispatch,
  SSOid,
  children
}) {
  const [openPause, setPauseOpen] = useState(false);
  const [openEndPause, setEndPauseOpen] = useState(false);

  const openPauseModal = useCallback(() => setPauseOpen(true), []);
  const closePauseModal = useCallback(() => setPauseOpen(false), []);

  const openEndPauseModal = useCallback(() => setEndPauseOpen(true), []);
  const closeEndPauseModal = useCallback(() => setEndPauseOpen(false), []);

  const value = {
    openPause,
    setPauseOpen,
    openPauseModal,
    closePauseModal,
    openEndPause,
    setEndPauseOpen,
    openEndPauseModal,
    closeEndPauseModal,
    intl,
    router,
    dispatch,
    SSOid,
    spaceID,
    spaceTitle,
    spaceImage,
    spaceAddress,
    listingID,
    listingsIDs,
    listingStatus,
    listingType
  };

  return (
    <PauseModalContext.Provider value={value}>
      {children}
    </PauseModalContext.Provider>
  );
}

PauseModalProvider.propTypes = {
  spaceID: PropTypes.string,
  spaceTitle: PropTypes.string,
  spaceImage: PropTypes.string,
  spaceAddress: PropTypes.string,
  listingID: PropTypes.string,
  listingsIDs: PropTypes.array,
  listingStatus: PropTypes.string,
  listingType: PropTypes.object,
  intl: intlShape,
  router: PropTypes.shape({
    push: PropTypes.func
  }),
  dispatch: PropTypes.func,
  SSOid: PropTypes.string,
  children: PropTypes.node
};

PauseModalProvider.defaultProps = {
  spaceID: '',
  spaceTitle: '',
  spaceImage: '',
  spaceAddress: '',
  listingID: '',
  listingsIDs: [],
  listingStatus: '',
  listingType: {},
  router: {
    push: () => {}
  },
  dispatch: () => {},
  SSOid: '',
  children: null
};

export function usePauseModal () {
  const ctx = useContext(PauseModalContext);
  if (!ctx) {
    throw new Error('usePauseModal must be used within <PauseModalProvider>');
  }
  return ctx;
}
